import * as styles from './button.module.scss';

import { Link } from 'gatsby';
import React from 'react';

const Button = ({ type, href, theme, size, style, children, ...props }) => {
  if (type === 'internal') {
    return (
      <Link
        to={href}
        className={`${styles.btn} ${styles[theme]} ${styles[size]}`}
        style={{ ...style }}>
        {children}
      </Link>
    );
  }
  if (type === 'submit') {
    return (
      <button
        type="submit"
        className={`${styles.btn} ${styles[theme]} ${styles[size]}`}
        style={{ ...style }}>
        {children}
      </button>
    );
  }
  if (type === 'button') {
    return (
      <button
        type="button"
        className={`${styles.btn} ${styles[theme]} ${styles[size]} ${props.className}`}
        style={{ ...style }}
        onClick={props.onClick}
        tabIndex={props.tabIndex}
        aria-label={props['aria-label']}>
        {children}
      </button>
    );
  }
  return (
    <a
      href={href}
      className={`${styles.btn} ${styles[theme]} ${styles[size]}`}
      style={{ ...style }}
      {...props}>
      {children}
    </a>
  );
};

export default Button;
